import { createBrowserRouter } from "react-router-dom";
import Company from "../components/Company/Company";
import Home from "../components/Home/Home";
import Login from "../components/Login/Login";
import Portfolio from "../components/PortFolio/Portfolio";
import UpdateForm from "../components/PortFolio/UpdateForm";
import Result from "../components/Result/Result";
import { Main } from "../layout/Main";
import PrivateRoute from "./PrivateRoute"; 
import Addportfolio from "../components/PortFolio/Addportfolio"
export const routes = createBrowserRouter([

    {
        path: "/",
        element: <Login />,
    },
    {
        path: "/",
        element: <PrivateRoute><Main /></PrivateRoute>,
        children: [
            {
                path: "/home",
                element: <PrivateRoute><Home /></PrivateRoute>,
            },
            {
                path: "/result",
                element: <PrivateRoute> <Result /></PrivateRoute>,
            },
            {
                path:"/portfolio",
                element: <PrivateRoute> <Portfolio/></PrivateRoute>
            },
            {
                path:`/portfolio/update/:id`,
                element: <PrivateRoute> <UpdateForm/></PrivateRoute>
            },
            {
                path:"/company",
                element: <Company/>
            },
            {
                path:"/addportfolio",
                element: <Addportfolio/>
            }
        ]
    },
    



]);